import React, { useRef, useEffect, useState, useMemo, useCallback } from "react";
import { useGLTF } from "@react-three/drei";
import { a } from '@react-spring/three'
import * as THREE from 'three'
import ModelScene from '../accests/3d/officce_n.glb'
import gsap from "gsap";



const Officce_n = (props) => {

  const { nodes, materials } = useGLTF(ModelScene);
  const [hovered, hover] = useState(false)
  const modelRef = useRef();
  const timeoutRef = useRef();
  // materials.плакат.metalness = .9
  const handlePointerOver = useCallback((event) => {
    event.stopPropagation();
    clearTimeout(timeoutRef.current);
    hover(true);
    props.setFog(true);
  }, [props.setFog]);

  const handlePointerOut = useCallback((event) => {
    timeoutRef.current = setTimeout(() => {
      hover(false);
      props.setFog(false);
    }, 150); // Небольшая задержка для предотвращения мерцания
  }, [props.setFog]);
  const colorChange = async () => {
    let key = Object.keys(materials)
    if (props.fog && !hovered)
      key.forEach(element => {
        // if (element != 'окна' && element != 'выступы')
        gsap.to(materials[element].emissive, 0.3, {
          r: 0.5,
          g: 0.5,
          b: 0.5
        });
      });
    else {
      key.forEach(element => {
        // if (element != 'окна' && element != 'выступы')
        gsap.to(materials[element].emissive, 0.3, {
          r: 0,
          g: 0,
          b: 0
        });
      });
    }
  }
  // useEffect(() => {
  //   colorChange()
  // }, [props.fog])
  useEffect(() => {
    const key = Object.keys(materials);

    if (props.fog && !hovered) {
      key.forEach(element => {
        gsap.to(materials[element].emissive, 0.3, {
          r: 0.5,
          g: 0.5,
          b: 0.5
        });
      });
    } else {
      key.forEach(element => {
        gsap.to(materials[element].emissive, 0.3, {
          r: 0,
          g: 0,
          b: 0
        });
      });
    }
  }, [props.fog, hovered, materials]);

  // Очистка таймера при размонтировании
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  return (
    <a.group {...props} ref={modelRef}
      // onPointerOver={(event) => {
      //   event.stopPropagation()
      //   hover(true)
      //   props.setFog(true)
      // }
      // }
      // onPointerOut={(event) => {
      //   hover(false)
      //   props.setFog(false)
      // }}
      onPointerOver={handlePointerOver}
      onPointerOut={handlePointerOut}
      onClick={() => { props.select(8) }}
    >
      <group name="Scene">
        <group name="Officce" position={[-32.884, 0, -25.21]} scale={1.741}>
          <mesh
            name="Circle039"
            castShadow
            receiveShadow
            geometry={nodes.Circle039.geometry}
            material={materials.плакат}
            position={[23.471, -4.783, 19.987]}
            rotation={[0.006, -0.037, 0.007]}
            scale={[0.332, 0.332, 0.335]}
          />
          <group name="Здание" position={[18.891, 0, 14.483]} scale={2.116}>
            <mesh
              name="Cube004"
              castShadow
              receiveShadow
              geometry={nodes.Cube004.geometry}
              material={materials['Material.003']}
            />
            <mesh
              name="Cube004_1"
              castShadow
              receiveShadow
              geometry={nodes.Cube004_1.geometry}
              material={materials.дверь}
            />
            <mesh
              name="Cube004_2"
              castShadow
              receiveShadow
              geometry={nodes.Cube004_2.geometry}
              material={materials['Material.004']}
            />
            <mesh
              name="Cube004_3"
              castShadow
              receiveShadow
              geometry={nodes.Cube004_3.geometry}
              material={materials['Material.005']}
            />
            <mesh
              name="Cube004_4"
              castShadow
              receiveShadow
              geometry={nodes.Cube004_4.geometry}
              material={materials['ступеньки.001']}
            />
            <mesh
              name="Cube004_5"
              castShadow
              receiveShadow
              geometry={nodes.Cube004_5.geometry}
              material={materials['Material.006']}
            />
          </group>
          <mesh
            name="боковые_заглушки"
            castShadow
            receiveShadow
            geometry={nodes.боковые_заглушки.geometry}
            material={materials['Material.004']}
            position={[18.891, 0, 14.483]}
            scale={0.068}
          />
          <mesh
            name="окно"
            castShadow
            receiveShadow
            geometry={nodes.окно.geometry}
            material={materials.стекло}
            position={[18.891, 0, 14.483]}
            scale={2.116}
          />
          <mesh
            name="рамы"
            castShadow
            receiveShadow
            geometry={nodes.рамы.geometry}
            material={materials['Material.004']}
            position={[18.891, 0, 14.483]}
            scale={[2.116, 2.25, 0.06]}
          />
        </group>
      </group>
    </a.group>
  );
}

export default Officce_n;